import { FlexBox } from '../common/boxes';
import { Loader } from '../common/Loader';
import { Box, Typography } from '@mui/material';
import { Business } from '@mui/icons-material';
import { useMemo } from 'react';
import { useGetClientsList } from '../../queryHooks/client/useGetClientsList';
import { PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_SIZE } from '../../core/pagination';
import { CUSTOMER_STATUS_MAP } from '../../enums/customerStatus';

const ClientInfo = ({ clientId }: { clientId: number }) => {
  const { data: clientList, isFetching } = useGetClientsList({
    search: {
      id: clientId,
      page: PAGINATION_DEFAULT_PAGE,
      size: PAGINATION_DEFAULT_SIZE
    },
    refetchOnWindowFocus: false
  });
  const client = useMemo(() => clientList?.content[0], [clientList]);

  return (
    <>
      {
        isFetching && <Box position={'relative'}><Loader width={50}/></Box>
      }
      {
        client &&
        <FlexBox flexDirection={{ mobile: 'column', tablet: 'row' }} flexWrap={'wrap'}>
          <Business color={'primary'} sx={{ mr: 2 }}/>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Legal Name:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {client.legalName}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Email:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {client.email}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Contact Name:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {client.contactName}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Phone:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {client.phone}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Status:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {CUSTOMER_STATUS_MAP[client.status]}
            </Typography>
          </FlexBox>

        </FlexBox>
      }
    </>
  );
};

export default ClientInfo;